__turbopack_context__.v({
  "bold": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__bold",
  "container": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__container",
  "content": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__content",
  "contentHeader": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__contentHeader",
  "contentWrapper": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__contentWrapper",
  "description": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__description",
  "detailedBlock": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__detailedBlock",
  "discountContainer": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__discountContainer",
  "discountValue": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__discountValue",
  "divider": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__divider",
  "header": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__header",
  "introducerFeeBlock": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__introducerFeeBlock",
  "introducerFeeTitleBlock": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__introducerFeeTitleBlock",
  "logoImg": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__logoImg",
  "oldValues": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__oldValues",
  "price": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__price",
  "priceLayout": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__priceLayout",
  "root": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__root",
  "spaceBetween": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__spaceBetween",
  "textPadding": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__textPadding",
  "total": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__total",
  "vwfsInclude": "FinanceQuoteBreakdownModal-module-scss-module__x3hzEa__vwfsInclude",
});
